<section fxLayout="row" fxLayoutAlign="center start">
  <div fxFlex="300px" class="loginContainer" fxLayout="column" fxLayoutAlign="start center">
    <div fxFlex="60px" fxHide.lt-md></div>
    <h1>Registrieren</h1>
    <p class="text-login">Registrieren Sie sich beim Health+Life Adminportal.</p>
    <div fxLayout="row" style="width: 300px" fxLayoutAlign="center start">

      <form fxLayout="column" fxFlex="100%" fxLayoutGap="10px" #f="ngForm">
        <div fxLayout="column" fxLayoutGap="2px">
          <div fxLayout="row">
            <input type="text" fxFlex="100%" ngModel #email="ngModel" name="email" placeholder="Email-Adresse" email required>
          </div>
          @if (email.invalid && (email.dirty || email.touched)) {
            <div class="alert alert-danger">
              @if (email?.errors.required) {
                <div class="formError">
                  Bitte geben Sie Ihre Email-Adresse an
                </div>
              }
              @if (email?.errors.email) {
                <div class="formError">
                  Bitte geben Sie eine korrekte Email-Adresse an
                </div>
              }
            </div>
          }
        </div>
        <div fxLayout="column" fxLayoutGap="2px">
          <div fxLayout="row">
            <input type="password" fxFlex="100%" ngModel name="pwd1" placeholder="Passwort" minlength="6" required hintLabel="Muss mindestens 6 Zeichen lang sein" #pwd1="ngModel">
          </div>
          @if (pwd1.invalid && (pwd1.dirty || pwd1.touched)) {
            <div class="alert alert-danger">
              @if (pwd1.hasError('required')) {
                <div class="formError">Bitte geben Sie Ihr Passwort an</div>
              }
              @if (!pwd1.hasError('required') && (pwd1.value?.length < 6)) {
                <div class="formError">Ihr Passwort muss mindestens 6 Zeichen lang sein</div>
              }
            </div>
          }
        </div>
        <div fxLayout="column" fxLayoutGap="2px">
          <div fxLayout="row">
            <input type="password" fxFlex="100%" ngModel name="pwd2" placeholder="Passwort wiederholen" minlength="6" required (blur)="checkPasswordConsistency(f)" #pwd2="ngModel">
          </div>
          @if (pwd2.invalid && (pwd2.dirty || pwd2.touched)) {
            <div class="alert alert-danger">
              @if (pwd2.hasError('required')) {
                <div class="formError">Bitte geben Sie Ihr Passwort erneut an</div>
              }
              @if (!pwd2.hasError('required') && (pwd2.value?.length < 6)) {
                <div class="formError">Ihr Passwort muss mindestens 6 Zeichen lang sein</div>
              }
            </div>
          }
        </div>
        @if (pwd2.hasError('incorrect')) {
          <div class="formErrorBox" fxLayout="row" fxLayoutAlign="start center">
            <div>
              Ihre angegebenen Passwörter stimmen nicht überein
            </div>
          </div>
        }

        <div style="margin-top:20px; padding-bottom:20px" fxLayoutGap="15px" fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <mat-checkbox ngModel name="nutzungsbedingungen" value="1" required></mat-checkbox>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <a href="https://semmily.com/agb" target="_blank" class="checkboxText">Ich akzeptiere die <span class="ci-grass">Nutzungsbedingungen</span></a>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <mat-checkbox ngModel name="datenschutzbestimmungen" value="1" required></mat-checkbox>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <a href="https://semmily.com/datenschutz" target="_blank" class="checkboxText">Ich akzeptiere die <span class="ci-grass">Datenschutzbestimmungen</span></a>
            </div>
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
          <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
            <button class="button yellow" type="button" color="primary" (click)="onSignupWithPassword(f)" [disabled]="!f.touched || !f.valid">Registrieren</button>
          </div>
          <div style="margin-top:20px;" fxLayout="row" fxLayoutGap="5px" class="register" fxLayoutAlign="center">
            <div>Sie haben schon einen Account?</div>
            <a routerLink="/login" class="ci-aqua" style="cursor: pointer; text-decoration: none">Anmelden</a>
          </div>
        </div>
      </form>

    </div>
    <div fxFlex="20px"></div>
    <img src="../../../assets/img/HEALTH+LIFE-MED.png" width="73"/>
  </div>
</section>
